import { render, staticRenderFns } from "./DaisyMapping.vue?vue&type=template&id=5e50fa58&"
import script from "./DaisyMapping.vue?vue&type=script&lang=ts&"
export * from "./DaisyMapping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports